import { EMPTY_VALUES } from "../../Apis/functions";

/**
 * Author: Arnulfo Ferro Zapata
 * Job Title: Fullstack
 * Email: azpata@ibl.mx
 *
 * Single label/value row used by the summary containers. When `twoColumns` is
 * false only the label is rendered (used as a plain title row). A null/empty
 * string value falls back to the default empty placeholder.
 *
 * @param {Object} props
 * @param {string} props.label - Translation key for the row label.
 * @param {string|JSX.Element} [props.value] - Row value; string or rendered node.
 * @param {Function} props.t - Translation function.
 * @param {string} [props.className=''] - Extra classes for the wrapper.
 * @param {string} [props.classNameValue=''] - Extra classes for the value paragraph.
 * @param {boolean} [props.twoColumns=true] - When true, renders the value row.
 * @returns {JSX.Element}
 */
const SummaryItem = ({ label, value, t, className = '', classNameValue = '', twoColumns = true }) => {

    return (
        <div className={`row w-100 background-shades-50 border-radius-8px p-12px gap-12px ${className}`}>
            <p className="font-color-general-950 ibl-font-w-600 fs-14px col-12 col-lg-5  p-0">
                {t(label)}
            </p>
            {twoColumns &&
                <p className={`font-color-shades-800 ibl-font-w-400 fs-14px col-12 col-lg-5 p-0 ${classNameValue}`}>
                    {(value == null || value.trim?.() === '')
                        ? EMPTY_VALUES.DEFAULT
                        : value}
                </p>
            }

        </div>
    );
}

export default SummaryItem
